"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryInfo = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DeliveryInfo = ({
  deliveryDate,
  emptyFeeLabel,
  fee,
  isFreeDelivery
}) => {
  const ownerState = {
    isFreeDelivery
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DeliveryInfoWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Fee, {
      ownerState: ownerState,
      children: isFreeDelivery ? emptyFeeLabel : fee
    }), deliveryDate ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      color: "textSecondary",
      children: deliveryDate
    }) : null]
  });
};
exports.DeliveryInfo = DeliveryInfo;
var _default = exports.default = DeliveryInfo;
